import ICDiscord from "@/components/Icon/ICFooter/ICDiscord";
import ICTele from "@/components/Icon/ICFooter/ICTelegram";
import ICX from "@/components/Icon/ICFooter/ICX";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";

import { ICLogo } from "@/components/Icon/ICLogo";
import config from "@/config";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export default function MobileFooter() {
  const { t } = useTranslation();
  return (
    <footer className="w-full text-white py-4 px-6 flex flex-col bg-gradient-to-b from-black/20 to-black/90">
      {/* Logo and copyright */}
      <div className="flex flex-col items-center mb-3">
        <Link to="/" className="flex items-center mb-1">
          <ICLogo width="32" height="32" className="mr-2" />
          <span className="text-lg font-bold">MoneyFi</span>
        </Link>
        <span className="text-sm">© 2025 moneyfi.fund</span>
      </div>

      {/* Links */}
      <div className="flex justify-center items-center text-xs text-gray-400">
        <Link to="/" className="hover:text-white transition-colors">
          {t("footer.terms")}
        </Link>
        <span className="mx-2">|</span>
        <Link to="/" className="hover:text-white transition-colors">
          {t("footer.privacy")}
        </Link>
      </div>

      {/* Social Media */}
      <div className="flex justify-center items-center text-xs text-gray-400 gap-2 mt-2">
        <a href={config.SOCIAL.FACEBOOK} className="flex items-center">
          <FacebookRoundedIcon
            sx={{ color: "var(--gray-5)", fontSize: "28px" }}
          />
        </a>
        <a href={config.SOCIAL.TELEGRAM} className="flex items-center">
          <ICTele width="24" height="24" />
        </a>
        <a href={config.SOCIAL.DISCORD} className="flex items-center">
          <ICDiscord width="24" height="24" />
        </a>
        <a href={config.SOCIAL.TWITTER} className="flex items-center">
          <ICX width="24" height="24" />
        </a>
      </div>
    </footer>
  );
}
